
import { FirmWareUpdateActions, FirmWareUpdateActionTypes } from '../actions/firm-ware-update.actions';

export interface State {
  Loaded: boolean;
  Loading: boolean;
}

export const initialState: State = {
  Loaded: false,
  Loading: false
};

export function reducer(state = initialState, action: FirmWareUpdateActions): State {
  switch (action.type) {

    case FirmWareUpdateActionTypes.GetFirmWareUpdates:
      return {...state, Loaded: false, Loading: true};
    case FirmWareUpdateActionTypes.LoadFirmWareUpdates:
      return {...state, Loaded: true, Loading: false};

    default:
      return state;
  }
}
